import React from 'react';

export const defaultFormContext = {
  ee: null,
  focusFirstField: false,
  hideCancel: false,
  hideReset: false,
  hideSubmit: false,
  hideToolbar: false,
  manager: {},
  onTableFilter: null,
  onValidationReport: null,
};

const uncontrolled = ['disabled', 'hidden', 'originalValue', 'touched', 'valid', 'calculated'];

export const skipUpdate = (prev, next) => {
  const isAutoCalculated = next.calculated === true;
  if (isAutoCalculated || next.alwaysUpdate) {
    return false;
  }

  for (const item of uncontrolled) {
    if (prev[item] !== next[item]) {
      // Only want valid to cause a re-render if the field has been touched
      if (item === 'valid') {
        if (next.touched) {
          return false;
        }
      } else {
        return false;
      }
    }
  }

  return true;
};

export const FormContext = React.createContext({ ...defaultFormContext });

export const withFormContext = Component => {
  return React.forwardRef(({ context: parentContext = {}, ...props }, ref) => (
    <FormContext.Consumer>
      {context => <Component {...props} context={{ ...context, ...parentContext }} ref={ref} />}
    </FormContext.Consumer>
  ));
};
